import { useMutation } from '@tanstack/react-query';
import { Input, Space } from 'antd';
import { IPrices } from 'models/prices.model';
import { useState } from 'react';
import { userService } from 'services';
import { userStore } from 'stores';

interface UpdateConfigFormProps {
  id: keyof IPrices;
  price: number;
}

export const UpdateConfigForm = ({ id, price }: UpdateConfigFormProps) => {
	const [value, setValue] = useState(price);
	const update = useMutation({
		mutationFn: (newPrice: number) => userService.updatePrice(id, newPrice),
		onSuccess: (data) => {
			userStore.updatePrice(data.name, data.value);
		}
	});

	return (
		<Space.Compact block style={{ marginBottom: 20 }}>
			<Input.Search 
				value={value}
				onChange={(event) => setValue(+event.target.value)}
				addonBefore={id}
				prefix="$"
				enterButton="Update"
				onSearch={(value) => update.mutate(+value)}
				type="number"
				loading={update.isPending}
			/>
		</Space.Compact>
	);
};
